export var Breakpoints;
(function (Breakpoints) {
    Breakpoints["xs"] = "XS";
    Breakpoints["s"] = "S";
    Breakpoints["m"] = "M";
    Breakpoints["l"] = "L";
    Breakpoints["xl"] = "XL";
})(Breakpoints || (Breakpoints = {}));
//# sourceMappingURL=breakpoints.js.map